/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/prefer-inject */
/* eslint-disable @angular-eslint/component-selector */
import { Component, ElementRef, ViewChild } from '@angular/core';
import { AppMenu } from './app.menu';
import { LayoutService } from '@/layout/service/layout.service';
import { RouterModule } from '@angular/router';
import { SHARED_IMPORTS } from '../../utils/other/standalone-import';

@Component({
  selector: '[app-sidebar]',
  standalone: true,
  imports: [SHARED_IMPORTS, AppMenu, RouterModule],
  template: ` <div
    class="layout-sidebar"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()">
    <a [routerLink]="['/']" class="app-logo">
      <div class="flex side-nav-logo">
        <img
          class="logo"
          src="../../assets/images/logo.png"
          [alt]="'general.appName' | translate" />
        <img
          class="logo-dark"
          src="../../assets/images/logo-dark.png"
          [alt]="'general.appName' | translate" />

        <div class="logo-line"></div>
      </div>
    </a>
    <button
      class="layout-sidebar-anchor p-link z-2"
      type="button"
      (click)="anchor()"></button>

    <div #menuContainer class="layout-menu-container">
      <app-menu></app-menu>
    </div>
  </div>`
})
export class AppSidebar {
  timeout: any = null;

  @ViewChild('menuContainer') menuContainer!: ElementRef;

  constructor(
    public layoutService: LayoutService,
    public el: ElementRef
  ) {}

  onMouseEnter() {
    if (!this.layoutService.layoutState().anchored) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.layoutService.layoutState.update((state) => {
        if (!state.sidebarActive) {
          return {
            ...state,
            sidebarActive: true
          };
        }
        return state;
      });
    }
  }

  onMouseLeave() {
    if (!this.layoutService.layoutState().anchored) {
      if (!this.timeout) {
        this.timeout = setTimeout(() => {
          this.layoutService.layoutState.update((state) => {
            if (state.sidebarActive) {
              return {
                ...state,
                sidebarActive: false
              };
            }
            return state;
          });
        }, 300);
      }
    }
  }

  anchor() {
    this.layoutService.layoutState.update((state) => ({
      ...state,
      anchored: !state.anchored
    }));
  }
}
